import { format } from "date-fns";
import { useTranslation } from "react-i18next";
import { Notice } from "components/notice";

export const PrePublicationBanner = ({
  bookTitle,
  publishedAt,
}: {
  bookTitle: string;
  publishedAt: Date;
}) => {
  const { t } = useTranslation(["productDetails"]);
  const date = format(publishedAt, "d MMMM yyyy");

  return (
    <Notice
      variant="hint"
      data-testid="pre-publication-banner"
      title={t("salesData.banner.prePublication.title", {
        title: bookTitle,
        date,
      })}
    >
      {t("salesData.banner.prePublication.body", { title: bookTitle, date })}
    </Notice>
  );
};
